<template>
  <div>
    <!-- <task-detail @onSave="refreshStages" @onDelete="refreshStages" /> -->
    <task-detail />

    <b-row>
      <b-col md="7" offset-md="2">
        <h1 class="title text-center mb-4">{{ $t("roadmap.ddo.text") }}</h1>
        <div class="alert alert-info m-4">
          <h6>
            {{ $t("roadmap.init-alert") }}
          </h6>
        </div>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="DDO_PRODUCT_ROADMAP" definition="DDO_PLANNING" :title="$t('roadmap.stage.ddo-planning')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="DDO_PRODUCT_ROADMAP" definition="DDO_APPLY" :title="$t('roadmap.stage.ddo-apply')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="DDO_PRODUCT_ROADMAP" definition="DDO_CONTROL_AND_PREVENTION" :title="$t('roadmap.stage.ddo-control-and-prevention')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="DDO_PRODUCT_ROADMAP" definition="DDO_CHANGE_MANAGEMENT" :title="$t('roadmap.stage.ddo-change-management')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { EventBus } from "@modules/websocket";
import Stage from "./component/roadmap-stage";

export default {
  components: { Stage },
  mounted() {
    const stages = ["DDO_PLANNING", "DDO_APPLY", "DDO_CONTROL_AND_PREVENTION", "DDO_CHANGE_MANAGEMENT"];

    EventBus.$on("task-board-update", (e) => {
      stages.forEach((stage) => {
        this.loadStage(stage);
      });
    });

    EventBus.$on("roadmap-stage-updated", (e) => {
      e.stages.forEach((stage) => {
        this.loadStage(stage);
      });
    });
  },
  methods: {
    // refreshStages(item) {
    //   setTimeout(() => {
    //     const stage = item?.relations?.roadmapStage;
    //     if (stage?.roadmapDefinition == "DDO_PRODUCT_ROADMAP") {
    //       this.loadStage(stage?.definition);
    //       stage.next.forEach((s) => this.loadStage(s));
    //     }
    //   }, 4000);
    // },
    async loadStage(stage) {
      try {
        this.isLoading = true;
        await this.$store.dispatch(`organizationRoadmap/loadStage`, { roadmap: "DDO_PRODUCT_ROADMAP", stage });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./roadmap";
</style>
